import React, { useState, useEffect } from 'react';
import styled, {keyframes } from 'styled-components/macro';

import grass from '../resources/grass.svg';
import logo from '../resources/logo-percy.png';
import logoMS from '../resources/logo-brand.svg';

import percyHead1 from '../resources/head.webp';
import percyBody1 from '../resources/body.webp';
import percyHead2 from '../resources/head_R.webp';
import percyBody2 from '../resources/body_R.webp';
import percyHead3 from '../resources/head_O.webp';
import percyBody3 from '../resources/body_O.webp';
import percyHead4 from '../resources/head_Y.webp';
import percyBody4 from '../resources/body_Y.webp';
import percyHead5 from '../resources/head_B.webp';
import percyBody5 from '../resources/body_B.webp';
import percyHead6 from '../resources/head_G.webp';
import percyBody6 from '../resources/body_G.webp';

import top1 from '../resources/hat/hat1.png';
import top2 from '../resources/hat/hat2.png';
import top3 from '../resources/hat/hat3.png';
import mid1 from '../resources/top/tshirt1.png';
import mid2 from '../resources/top/tshirt2.png';
import bot1 from '../resources/shoes/shoes1.png';
import bot2 from '../resources/shoes/shoes2.png';
import bot3 from '../resources/shoes/shoes3.png';

const heads = [percyHead1, percyHead2, percyHead3, percyHead4, percyHead5, percyHead6]
const bodys = [percyBody1, percyBody2, percyBody3, percyBody4, percyBody5, percyBody6]
const tops = [top1, top2, top3];
const mids = [mid1, mid2];
const bots = [bot1, bot2, bot3];

const wiggle = keyframes`
  0% {
    transform: rotate(4deg);
  }
  50% {
    transform: rotate(-4deg);
  }
  100% {
    transform: rotate(4deg);
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  /* overflow: hidden; */

  & button {
    position: absolute;
    font-weight: bolder;
    font-size: 100px;
    z-index: 100;
    margin: 0;
    padding: 8px;
  }
`;

const PercyContainer = styled.div`
  background-color: #EF5196;
  /* width: 300px; */
  height: 550px;
`;

const HeadContainer = styled.div`
  position: relative;
  top: 150px;
  left: auto;
  right: auto;
  transform-origin: 50% 59.7%;
  animation-name: ${wiggle};
  animation-duration: 2s;
  animation-fill-mode: forward;
  animation-iteration-count: infinite;
  z-index: 2;
`;

const BodyContainer = styled.div`
  position: relative;
  top: 255px;
  left: auto;
  right: auto;
  z-index: 1;
`;

const HeadImg = styled.img`
  position: absolute;
  width: 150px;
  height: auto;
  left: 50%;
  transform: translateX(-50%);
`;

const BodyImg = styled.img`
  position: relative;
  width: 300px;
  height: auto;
`;

const Hat = styled.img`
  position: absolute;
  width: 120px;
  height: auto;
  left: 50%;
  transform: translate(-50%, -57%);
`;

const Top = styled.img`
  position: absolute;
  width: 280px;
  height: 120px;
  left: 50%;
  transform: translate(-52%, -0%);
`;

const Shoes = styled.img`
  position: absolute;
  width: 230px;
  height: auto;
  left: 50%;
  top: 40px;
  transform: translate(-50%, -0%);
`;

const Percy = () => {
  const [col, setCol] = useState(0);
  const [top, setTop] = useState(0);
  const [mid, setMid] = useState(0);
  const [bot, setBot] = useState(3);
  const [, setTopA] = useState([]);
  const [, setMidA] = useState([]);
  const [, setBotA] = useState([]);
  useEffect(() => {
    fetch("https://arcane-caverns-09499.herokuapp.com/get-user/apurv")
      .then(response => response.json())
      .then(data => {
        console.log(data);
        setTop(data['percy']['clothes']['hat'].current);
        setMid(data['percy']['clothes']['top'].current);
        setBot(data['percy']['clothes']['shoes'].current);
        setTopA(data['percy']['clothes']['hat'].available);
        setMidA(data['percy']['clothes']['top'].available);
        setBotA(data['percy']['clothes']['shoes'].available);
      });
  }, []);
  return (
    <Container>
      <button style={{ top: '150px', left: 0 }} onClick={() => setCol((col + 5) % 5)}>&lt;</button>
      <button style={{ top: '150px', right: 0 }} onClick={() => setCol((col + 1) % 5)}>&gt;</button>

      <button style={{ top: '50px', left: 0 }} onClick={() => setTop((top + 2) % 3)}>&lt;</button>
      <button style={{ top: '250px', left: 0 }} onClick={() => setMid((mid + 1) % 2)}>&lt;</button>
      <button style={{ top: '350px', left: 0 }} onClick={() => setBot((bot + 2) % 3)}>&lt;</button>
      <button style={{ top: '50px', right: 0 }} onClick={() => setTop((top + 1) % 3)}>&gt;</button>
      <button style={{ top: '250px', right: 0 }} onClick={() => setMid((mid + 1) % 2)}>&gt;</button>
      <button style={{ top: '350px', right: 0 }} onClick={() => setBot((bot + 1) % 3)}>&gt;</button>
      <img src={grass} className='grass' alt="" style={{ position: 'absolute', bottom: 0, left: '-50px', width: '300%' }} />
      <img src={logo} className='logo' alt="" style={{ position: 'absolute', top: 0, right: 0, width: '200px' }} />
      <img src={logoMS} className='logo' alt="" style={{ position: 'absolute', top: "-20px", left: "10px", width: '200px' }} />
      <PercyContainer>
        <HeadContainer>
          <HeadImg src={heads[col]} alt="" />
          <Hat src={tops[top]} alt="" />
        </HeadContainer>
        <BodyContainer>
          <BodyImg src={bodys[col]} alt="" />
          <Top src={mids[mid]} alt="" />
          <Shoes src={bots[bot]} alt="" />
        </BodyContainer>
      </PercyContainer>
    </Container>
  )
};

export default Percy;
